import { selectSeatDistribution } from "../../../utils/SeatDistributionUtil";

type ApplySeatDistributionParams = {
  selectedItem: any;
  seats: any[];
  distributionKey: any;
  startsAt?: number;
  reverse?: boolean;
  setSeatValue: (seatObj: any, selectedItem: any, value: string ) => void;
  distributionObject: string;
};

export class RowSeatLabelHelper {
  static applySeatDistribution({
    selectedItem,
    seats,
    distributionKey,
    startsAt = 1,
    reverse = false,
    setSeatValue,
    distributionObject,
  }: ApplySeatDistributionParams) {
    if (!seats?.length) return;

    const list = selectSeatDistribution(
      distributionKey,
      seats.length,
      startsAt,
      reverse
    );

    for (let index = 0; index < seats.length; index++) {
      const seatObj = seats[index];
      const textObj = seatObj.item(1);

      if (textObj) {
        textObj.set({
          text: list[index] ?? '',
        });
      }

      seatObj.set({
        label: list[index] ?? '',
      });

      setSeatValue(seatObj, selectedItem, list[index]);
    }
    
    selectedItem.set({
      [distributionObject]: {
        key: distributionKey,
        list,
        startsAt,
        reverse,
      },
    });
  }
}